import Vue from 'vue'
import store from '@/store/index.js'

/* 格式化价格 */
function formatPrice(val, symbol = '') {
  val = parseFloat(val)
  return isNaN(val) ? '' : symbol + val.toFixed(2)
}

/* 格式化带货币的价格 */
function formatCurrency(val, symbol) {
  symbol = symbol || store.getters.currencySymbol
  return formatPrice(val, symbol)
}

function dateFormat(fmt = 'YYYY-MM-DD hh:mm', date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'M+': (date.getMonth() + 1).toString(), // 月
    'D+': date.getDate().toString(), // 日
    'h+': date.getHours().toString(), // 时
    'm+': date.getMinutes().toString(), // 分
    's+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].slice(-ret[1].length).padStart(ret[1].length, '0')))
    }
  }
  return fmt
}

Vue.filter('formatCurrency', formatCurrency)
Vue.filter('formatPrice', formatPrice)
Vue.filter('formatDate', function(val, fmt = 'YYYY-MM-DD hh:mm') {
  if (!val) return ''

  const date = typeof val === 'string' ? new Date(val.replace(/-/g, '/')) : val
  return dateFormat(fmt, date)
})

export {
  formatCurrency,
  formatPrice,
  dateFormat
}
